/**
 * Rende trascinabili le immagini di .about-gallery (moodboard collage) per
 * tutti i visitatori. Al rilascio lo spostamento viene scritto nei margin
 * (non nei transform), così la grid ricalcola l'altezza della sezione.
 */
(function () {
  if (window.__aboutGalleryDraggableLoaded) return;
  window.__aboutGalleryDraggableLoaded = true;

  // Deve combaciare con $base-vw in src/scss/base/_mixins.scss (1920, non i
  // 1728px del canvas di design — quello è solo il valore passato a
  // rvw(1728) per la larghezza di .about-gallery__gallery).
  var BASE_VW = 1920;
  var GALLERY_SELECTOR = '.about-gallery';
  var CONTAINER_SELECTOR = '.about-gallery__gallery';
  var ITEM_SELECTOR = '.about-gallery__item';
  var PRESS_SCALE = 1.02;
  var PRESS_DURATION = 0.15;

  var instances = [];
  var topZRef = { z: 10 };

  function isPortrait() {
    return window.matchMedia('(orientation: portrait)').matches;
  }

  function vwFactor() {
    return window.innerWidth > BASE_VW ? 1 : window.innerWidth / BASE_VW;
  }

  function pxToDesignUnits(px) {
    return px / vwFactor();
  }

  function rvwInlineValue(units) {
    var vw = (units / BASE_VW) * 100;
    return units >= 0 ? 'min(' + vw + 'svw, ' + units + 'px)' : 'max(' + vw + 'svw, ' + units + 'px)';
  }

  function currentMargins(el) {
    var style = window.getComputedStyle(el);
    return {
      top: parseFloat(style.marginTop) || 0,
      left: parseFloat(style.marginLeft) || 0,
    };
  }

  function commitDrag(el) {
    var x = gsap.getProperty(el, 'x');
    var y = gsap.getProperty(el, 'y');
    var margin = currentMargins(el);

    var topUnits = pxToDesignUnits(margin.top + y);
    var leftUnits = pxToDesignUnits(margin.left + x);

    // Il margin va scritto via DOM diretto: gsap.set() interpola le proprietà
    // CSS estraendo i numeri dalla stringa, e un'espressione min(...) con più
    // numeri al suo interno confonde quel parsing (il transform si azzera ma
    // il margin resta quello originale). x/y restano su gsap.set perché sono
    // proprietà numeriche semplici che gestisce senza ambiguità.
    // Stessa esecuzione sincrona = stesso frame di render, nessun flicker.
    el.style.marginTop = rvwInlineValue(topUnits);
    el.style.marginLeft = rvwInlineValue(leftUnits);
    gsap.set(el, { x: 0, y: 0 });
  }

  function waitForImages(gallery) {
    var imgs = Array.from(gallery.querySelectorAll('img'));
    return Promise.all(
      imgs.map(function (img) {
        if (img.complete) return Promise.resolve();
        return new Promise(function (resolve) {
          img.addEventListener('load', resolve, { once: true });
          img.addEventListener('error', resolve, { once: true });
        });
      }),
    );
  }

  function lockInitialHeight(container) {
    var heightPx = container.getBoundingClientRect().height;
    if (heightPx <= 0) return;
    container.style.minHeight = rvwInlineValue(pxToDesignUnits(heightPx));
  }

  function initGallery(gallery) {
    // Da portrait la moodboard va letta come collage statico, non trascinata.
    if (isPortrait()) return;

    var items = Array.from(gallery.querySelectorAll(ITEM_SELECTOR));
    var container = gallery.querySelector(CONTAINER_SELECTOR);
    if (!items.length || !container) return;

    lockInitialHeight(container);

    var hasInertia = typeof InertiaPlugin !== 'undefined';

    var created = Draggable.create(items, {
      type: 'x,y',
      bounds: container,
      inertia: hasInertia,
      allowContextMenu: false,
      onPress: function () {
        topZRef.z += 1;
        this.target.style.zIndex = topZRef.z;
        this.target.classList.add('is-dragging');
        gsap.to(this.target, { scale: PRESS_SCALE, duration: PRESS_DURATION, overwrite: 'auto' });
      },
      onRelease: function () {
        this.target.classList.remove('is-dragging');
        gsap.to(this.target, { scale: 1, duration: PRESS_DURATION, overwrite: 'auto' });
      },
      onDragEnd: function () {
        commitDrag(this.target);
      },
    });

    instances = instances.concat(created);
  }

  function destroy() {
    instances.forEach(function (draggable) {
      draggable.kill();
    });
    instances = [];
  }

  function init() {
    if (typeof gsap === 'undefined' || typeof Draggable === 'undefined') {
      console.warn('[about-gallery] GSAP Draggable non caricato.');
      return;
    }

    gsap.registerPlugin(Draggable);
    if (typeof InertiaPlugin !== 'undefined') gsap.registerPlugin(InertiaPlugin);

    document.querySelectorAll(GALLERY_SELECTOR).forEach(function (gallery) {
      waitForImages(gallery).then(function () {
        initGallery(gallery);
      });
    });
  }

  window.addEventListener('DOMContentLoaded', init);

  // Barba (page-transitions.js) sostituisce il container senza un reload
  // completo, quindi DOMContentLoaded non si ripete: bisogna reinizializzare
  // alla ricezione di 'page:loaded', ripulendo prima le istanze del
  // container precedente (già rimosso dal DOM da Barba).
  if (!(window.Shopify && Shopify.designMode)) {
    document.addEventListener('page:loaded', function () {
      destroy();
      init();
    });
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.querySelector(GALLERY_SELECTOR)) destroy();
    });
    document.addEventListener('shopify:section:load', function (event) {
      var gallery = event.target.querySelector(GALLERY_SELECTOR);
      if (gallery)
        waitForImages(gallery).then(function () {
          initGallery(gallery);
        });
    });
  }
})();
